import { useModal } from "@/hooks/modals/useModal";
import { useSourcingRequirementQuery } from "./useSourcingRequirementQuery";

export function useFormEditable() {
  const { props } = useModal("SOURCING_APPLICATION_20251202");

  const { isReadOnly } = props;
  const detail = useSourcingRequirementQuery(props.recordId);

  const isInReviewMode = props.mode === "inReview";
  const isStarted = props.mode === "started";

  if (!detail) {
    return {
      isStartedEditable: true,
      isInReviewEditable: false,
    };
  }

  if (isReadOnly || !detail) {
    return {
      isStartedEditable: false,
      isInReviewEditable: false,
    };
  }

  /**
   * mode 为 started 且审核状态为草稿或新建时，表单可编辑
   */
  const isStartedEditable =
    isStarted && (detail.reviewStatus === 1 || detail.reviewStatus === 3);

  /**
   * mode 为 inReview 且审核状态为申请中，新增的表单项可编辑
   */
  const isInReviewEditable = isInReviewMode && detail.reviewStatus === 2;

  return {
    isStartedEditable,
    isInReviewEditable,
  };
}
